import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allLanguages: [],
    allGeners: [],
    allChannels: [],
    allCountries: [],
    allFormats: [],
    allProdTypes: [],
    provience: [],
    selectedLanguages: [],
    selectedGenres: [],
    selectedChannels: [],
    selectedFormat: [],
    selectedProdType: [],
    allRejectionReasons: [],
    allScriptTypes: [],
    allClusters: [],
    allRoles: [],
    allReporting: [],
    allChannelsByClusterId:[],
    uspScriptTypes:[]
}
export const producerRegistrationSlice = createSlice({
    name: 'producerRegistration',
    initialState,
    reducers: {
        setAllLanguages: (state, action) => {
            state.allLanguages = action.payload.allLanguages;
        },
        setAllGeners: (state, action) => {
            state.allGeners = action.payload.allGeners;
        },
        setAllChannels: (state, action) => {
            state.allChannels = action.payload.allChannels;
        },
        setAllChannelsByClusterId: (state, action) => {
            state.allChannelsByClusterId = action.payload.allChannelsByClusterId;
        },
        setAllCountries: (state, action) => {
            state.allCountries = action.payload.allCountries;
        },
        setProvience: (state, action) => {
            state.provience = action.payload.provience;
        },
        setAllFormats: (state, action) => {
            state.allFormats = action.payload.allFormats;
        },
        setAllProdTypes: (state, action) => {
            state.allProdTypes = action.payload.allProdTypes;
        },
        setAllClusters: (state, action) =>{
            state.allClusters =action.payload.allClusters;
        },
        setAllRoles:(state, action) =>{
            state.allRoles= action.payload;
        },
        setAllReporting:(state, action) =>{
            state.allReporting=action.payload;
        },

        setSelectedData: (state, action) => {
            if (action.payload.option === "Channels") {
                state.selectedChannels.push({ "channelId": action.payload.element });
            }
            else if (action.payload.option === "Languages") {
                state.selectedLanguages.push({ "languageId": action.payload.element });
            }
            else if (action.payload.option === "Genres") {
                state.selectedGenres.push({ "genreId": action.payload.element });
            }
            else if (action.payload.option === "Formats") {
                state.selectedFormat.push({ "formatId": action.payload.element });
            }
            else if (action.payload.option === "ProdTypes") {
                state.selectedProdType.push({ "productionTypeId": action.payload.element });
            }
        },
        removeSelectedData: (state, action) => {

            if (action.payload.option === "Channels") {
                const updatedList = state.selectedChannels.filter(item => item.channelId !== action.payload.element);
                state.selectedChannels = updatedList;
            }
            else if (action.payload.option === "Languages") {
                const updatedList = state.selectedLanguages.filter(item => item.languageId !== action.payload.element);
                state.selectedLanguages = updatedList;
            }
            else if (action.payload.option === "Genres") {
                const updatedList = state.selectedGenres.filter(item => item.genreId !== action.payload.element);
                state.selectedGenres = updatedList;
            }
            else if (action.payload.option === "Formats") {
                const updatedList = state.selectedFormat.filter(item => item.formatId !== action.payload.element);
                state.selectedFormat = updatedList;
            }
            else if (action.payload.option === "ProdTypes") {
                const updatedList = state.selectedProdType.filter(item => item.productionTypeId !== action.payload.element);
                state.selectedProdType = updatedList;
            }
        },
        removeAllData: (state, action) => {
            if (action.payload.option === "Channels") {
                state.selectedChannels.splice(0, state.selectedChannels.length);
            }
            else if (action.payload.option === "Languages") {
                state.selectedLanguages.splice(0, state.selectedLanguages.length);
            }
            else if (action.payload.option === "Genres") {
                state.selectedGenres.splice(0, state.selectedGenres.length);
            }
            else if (action.payload.option === "Formats") {
                state.selectedFormat.splice(0, state.selectedFormat.length);
            }
            else if (action.payload.option === "ProdTypes") {
                state.selectedProdType.splice(0, state.selectedProdType.length);
            }
        },
        setAllFormats: (state, action) => {
            state.allFormats = action.payload.allFormats;
        },
        setAllProdType: (state, action) => {
            state.allProdTypes = action.payload.allProdTypes;
        },
        setAllRejectionReasons: (state, action) => {
            state.allRejectionReasons = action.payload.allRejectionReasons;
        },
        setAllScriptTypes: (state, action) => {
            state.allScriptTypes = action.payload.allScriptTypes;
        },
        setUSPScriptTypes:(state, action)=>{
            state.uspScriptTypes=action.payload.uspScriptTypes;
        },
        clearAllRoles: (state) => {
            state.allRoles = [];
        },
        clearAllClusters: (state) => {
            state.allClusters = [];
        },
        clearAllReporting: (state) => {
            state.allReporting = [];
        },
        clearAllFormats: (state) => {
            state.allFormats = [];
        },
        clearAllProdTypes: (state) => {
            state.allProdTypes = [];
        },
        clearAllChannels: (state) => {
            state.allChannels = [];
        },
        clearAllCountries: (state) => {
            state.allCountries = [];
        }
    }
})

export const { setAllLanguages, setAllGeners, setAllChannels, setAllCountries, setProvience, setSelectedData, removeSelectedData, removeAllData, setAllFormats, setAllProdType,setAllClusters,setAllRoles,setAllReporting, setAllRejectionReasons, setAllScriptTypes, setAllChannelsByClusterId, setUSPScriptTypes, clearAllRoles,  clearAllClusters, clearAllReporting, clearAllFormats, clearAllProdTypes, clearAllChannels, clearAllCountries } = producerRegistrationSlice.actions

export default producerRegistrationSlice.reducer